import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5 9v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 9h3V5l7 7-7 7v-4H9V9z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowBigRightDash";
const ArrowBigRightDash = memo(themed(Icon));
export {
  ArrowBigRightDash
};
//# sourceMappingURL=arrow-big-right-dash.js.map
